<template>
  <div id="printArea"></div>
</template>

<script>
import i18n from '@/utils/i18n';
import * as PDFObject from 'pdfobject';
import { smallImg } from '@/assets/img';
import { mapGetters } from 'vuex';
import { parseTime } from '../../../utils';
let jsPDF = null;
const pm = 1.27;
let textsStartY = 0;
export default {
  name: 'PrintNew',
  model: {
    prop: 'printShow',
    event: 'close',
  },
  props: {
    printShow: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    isNeedAuthorise: {
      type: Boolean,
      default: false,
    },
    smallTipText: {
      type: String,
      default: '',
    },
    signTitle: {
      type: String,
      default: i18n.t('common.signature3'),
    },
    address: {
      type: String,
      default: '',
    },
    printTemplateStr: {
      type: String,
      default: '',
    },
    tableData: {
      type: Array,
      default: function () {
        return [];
      },
    },
    tableType: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapGetters(['name', 'hotelName']),
  },
  watch: {
    printShow(value) {
      if (value) {
        this.initPDF();
      }
    },
  },
  mounted() {
    if (this.printShow) {
      this.initPDF();
    }
  },
  methods: {
    initHeader() {
      textsStartY = 46;
      /* eslint-disable */
      let doc = new jsPDF({
        unit: 'px',
        format: 'ledger',
      });
      doc.setFont('Alibaba-PuHuiTi-Medium');
      doc.setFontType('normal');
      doc.setLineHeightFactor(2);
      doc.setFontSize(16);
      doc.addImage(smallImg, 'PNG', 10, (24 / pm).toFixed(2), 43, 13);
      let hotelName = `${this.hotelName}` || this.hotelName;
      const textWidth = doc.getTextWidth(`${hotelName}`);
      if (textWidth > 150) {
        doc.text(`${hotelName.substring(0, 12)}`, 10, textsStartY);
        doc.text(`${hotelName.substring(12, hotelName.length)}`, 10, textsStartY + 14);
        textsStartY += 20;
      } else {
        doc.text(`${hotelName}`, 10, textsStartY);
      }
      // doc.setFillColor(0, 0, 0);
      // doc.ellipse(52, 43, 1, 1, "F");
      // doc.setFontSize(12);
      doc.text(this.title, 10, ((textsStartY + 40) / pm).toFixed(2));
      doc.setDrawColor(0, 0, 0);
      doc.setLineWidth(0.5);
      doc.line(0, ((textsStartY + 56) / pm).toFixed(2), 156, ((textsStartY + 56) / pm).toFixed(2));
      return doc;
    },
    initPDF() {
      if (!jsPDF) {
        jsPDF = window.jsPDF;
      }
      let doc = this.initHeader();
      let arrString = this.printTemplateStr;
      doc.setFontSize(8);
      doc.text(arrString, 10, (textsStartY + 80) / pm);
      const count = Math.round((arrString.split('\r').length * 15 + (textsStartY + 80)) / pm);
      if (this.tableData.length) {
        let startY = 0;
        if (this.tableType === 'cost') {
          startY = this.initCostBillTable(doc, count);
        } else {
          startY = this.initTable(doc, count);
        }
        this.initFooter(doc, startY + 14);
      } else {
        this.initFooter(doc, count + 16);
      }
    },
    // 初始化房单相关的表格
    initTable(printObj, startY = 196) {
      const rate = 195 / 150;
      const tableOptions = {
        tableWidth: 146,
        margin: { left: 5 },
        theme: 'grid',
        columnStyles: {
          0: { cellWidth: Math.ceil(26 / rate) },
          1: { cellWidth: Math.ceil(42 / rate) },
          2: { cellWidth: Math.ceil(30 / rate) },
        },
      };
      const tableListData = [
        [
          this.$t('common.roomNumber'),
          this.$t('common.roomType'),
          this.$t('common.dayRate'),
          this.$t('common.checkInTime'),
          this.$t('common.checkOutTime'),
        ],
      ];
      this.tableData.map((item) => {
        const {
          roomNumber,
          roomTypeName,
          orderDayPriceList,
          arrivelHotelTime,
          departureHotelTime,
        } = item;
        tableListData.push([
          roomNumber,
          roomTypeName.length > 6 ? roomTypeName.substring(0, 6) : roomTypeName,
          calcCurrentDayPrice(orderDayPriceList),
          parseTime(arrivelHotelTime, '{y}-{m}-{d}'),
          parseTime(departureHotelTime, '{y}-{m}-{d}'),
        ]);
      });
      // NEW TABLE
      printObj.autoTable({
        body: tableListData,
        startY: startY,
        ...tableOptions,
        styles: {
          textColor: [0, 0, 0],
          font: 'Alibaba-PuHuiTi-Medium',
          lineColor: 10,
          lineWidth: 0.5,
          fontSize: 6,
          valign: 'middle',
        },
      });
      return printObj.lastAutoTable.finalY;
      function calcCurrentDayPrice(orderDayPriceList) {
        const today = orderDayPriceList.find((item) => item.roomDay === parseTime('{y}-{m}-{d}'));
        if (today) {
          return today.roomPrice;
        }
        return orderDayPriceList[orderDayPriceList.length - 1].roomPrice;
      }
    },
    // 初始化客房消费的表格
    initCostBillTable(printObj, startY = 196) {
      const rate = 195 / 150;
      const tableOptions = {
        tableWidth: 146,
        margin: { left: 5 },
        theme: 'grid',
        columnStyles: {
          0: { cellWidth: Math.ceil(89 / rate) },
          1: { cellWidth: Math.ceil(30 / rate) },
          2: { cellWidth: Math.ceil(30 / rate) },
        },
      };
      const tableListData = [
        [
          {
            content: this.$t('printsettingSmallprint.feeName'),
            styles: { halign: 'left' },
          },
          this.$t('common.unitPrice3'),
          this.$t('common.quantity'),
          this.$t('common.settlementAmount'),
        ],
      ];
      let list = [];
      this.tableData.map((item) => {
        const { subjectCode, subjectName, settleMoney, expenseMoney, goodsItemized } = item;
        if (subjectCode === '10011') {
          goodsItemized.map((goods) => {
            const { goodsName, num, price } = goods;
            tableListData.push([
              {
                content: goodsName,
                styles: { halign: 'left' },
              },
              price.toFixed(2),
              num,
              (price * num).toFixed(2),
            ]);
          });
        } else {
          if (item.settleMoney) {
            // 如果是付款科目
            tableListData.push([
              {
                colSpan: 3,
                content: subjectName,
                styles: { halign: 'left' },
              },
              (settleMoney || 0).toFixed(2),
            ]);
          } else {
            tableListData.push([
              {
                content: subjectName,
                styles: { halign: 'left' },
              },
              '',
              '',
              (settleMoney || expenseMoney || 0).toFixed(2),
            ]);
          }
        }
      });
      const tableDataLength = this.tableData.length - 1;
      let sumPrice =
        this.tableData[tableDataLength].settleMoney || this.tableData[tableDataLength].expenseMoney;
      if (this.tableData.every((item) => item.subjectCode === '10011')) {
        // 说明是小商品挂账
        sumPrice = this.tableData[0].goodsItemized.reduce((pre, next) => {
          const { price, num } = next;
          return pre.plus(price * num);
        }, 0);
      }
      tableListData.splice(tableListData.length - 1, 0, [
        {
          colSpan: 3,
          content: this.$t('printsettingSmallprint.totalConsumption'),
          styles: { halign: 'left' },
        },
        (sumPrice || 0).toFixed(2),
      ]);
      // NEW TABLE
      printObj.autoTable({
        body: tableListData,
        startY: startY,
        ...tableOptions,
        styles: {
          textColor: [0, 0, 0],
          font: 'Alibaba-PuHuiTi-Medium',
          lineColor: 10,
          lineWidth: 0.5,
          fontSize: 6,
          valign: 'middle',
          halign: 'right',
        },
      });
      return printObj.lastAutoTable.finalY;
    },
    initFooter(printObj, startY = 196) {
      printObj.setDrawColor(0, 0, 0);
      printObj.setLineWidth(0.5);
      if (!this.tableData.length) {
        printObj.line(0, startY - 14, 156, startY - 14);
      }
      let address = this.address;
      if (address.length > 19) {
        address = `${address.substring(0, 19)}\r${address.substring(19, address.length)}`;
      }
      printObj.text(
        `${this.$t('common.handledBy')}：${this.name} \r${this.$t(
          'common.printTime'
        )}：${this.formateTimesStamp(undefined, 'ymd hm')}\r${this.$t(
          'common.hotelAddress'
        )}：${address}`,
        10,
        startY
      );
      if (address.length > 19) {
        startY += 12;
      }
      printObj.line(0, startY + 34, 156, startY + 34);
      printObj.setFontSize(10);
      printObj.setDrawColor(153, 153, 153);
      if (this.smallTipText) {
        printObj.autoTable({
          body: [[this.smallTipText]],
          startY: startY + 46,
          tableWidth: 153,
          margin: 0,
          theme: 'grid',
          styles: {
            textColor: [0, 0, 0],
            font: 'Alibaba-PuHuiTi-Medium',
            fillColor: [153, 153, 153],
            valign: 'middle', // 居中
            halign: 'center', // 居中
            cellPadding: [8, 0, 8, 0], //间距
            fontSize: 8,
          },
        });
        if (this.isNeedAuthorise) {
          printObj.text(this.$t('common.signatureOfAuthorizer'), 10, startY + 96);
          printObj.text(this.signTitle, 10, startY + 130);
          printObj.line(0, startY + 174, 156, startY + 174);
        }
      } else {
        printObj.text(this.signTitle, 10, startY + 54);
        printObj.line(0, startY + 104, 156, startY + 104);
      }
      printObj.autoPrint();
      try {
        PDFObject.embed(printObj.output('datauristring'), '#printArea');
      } catch (e) {
        alert(`Error ${e}`);
      }
      // this.$emit('close', false)
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#printArea {
  width: 0;
  height: 0;
  visibility: hidden;
}

h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>
